import { WrenchScrewdriverIcon } from '@heroicons/react/24/outline';
import { CircularProgress } from '@nextui-org/react';
import React from 'react';

export const TableNoDataUi = (
  isLoading: boolean,
  isError: boolean,
  isNodata: boolean,
  override?: { loading?: string; error?: string; nodata?: string }
) => {
  if (!isNodata) {
    return undefined;
  }
  if (isLoading) {
    return (
      <div className='flex flex-wrap gap-2 justify-center content-center items-center'>
        <CircularProgress size='sm' aria-label='Loading...' />
        <p>{override?.loading ? override?.loading : 'Please wait, loading data.'}</p>
      </div>
    );
  }
  if (isError) {
    return (
      <div className='flex flex-wrap gap-2 justify-center content-center items-center'>
        <WrenchScrewdriverIcon strokeWidth={2} className='h-8 w-8' />
        <p>
          {override?.error
            ? override?.error
            : "Whoops, there something bad happen on the server. Please contact 'you know who.'"}
        </p>
      </div>
    );
  }
  return (
    <div className='flex flex-wrap gap-2 justify-center content-center items-center'>
      <p>{override?.nodata ? override?.nodata : 'No data available.'}</p>
    </div>
  );
};
